import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicAdditionalFeesNightsActive({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 45 29"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M36.2 0c.8 0 1.56.74 1.6 1.53V3.6H42a2.85 2.85 0 012.8 2.61V26.2c0 1.46-1.2 2.76-2.71 2.8l-.1.01H18.75c-1.59-.23-2.7-1.37-2.75-2.9V6.2c0-1.45 1.2-2.75 2.71-2.8H23V1.6c0-.51.25-1 .67-1.28l.08-.04.08-.05a1.68 1.68 0 011.57 0c.5.25.8.74.82 1.28V3.6h8.57V1.67l-.01-.07c-.16-.77.5-1.5 1.28-1.6h.14zm5.78 16.8l-23.16.01v9.17h23.16V16.8zM22.79 6.83h-3.97V14h23.16V6.82H38V8.8c0 .8-.74 1.57-1.54 1.61h-.07a1.7 1.7 0 01-1.61-1.53V6.82h-8.77V8.8c0 .55-.28 1.05-.75 1.33l-.08.04c-.52.26-1.05.26-1.57 0a1.5 1.5 0 01-.82-1.27V6.82z"
        fill="#F4F5FB"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgPicAdditionalFeesNightsActive.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicAdditionalFeesNightsActive.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicAdditionalFeesNightsActive svgRef={ref} {...props} />
));
export default ForwardRef;
